export default __webpack_public_path__ + "static/media/beWell.fa897561.png";